import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import EmailOptInSubscribeForm from 'core/modules/Forms/EmailOptInSubscribeForm';
import SlideMessage from '../SlideMessage/SlideMessage';
import SlideCounter from '../SlideCounter/SlideCounter';
import { postEmailOptInUserChoice } from 'core/modules/Modals/EmailOptInSubscribeModal/actions';
import { selectSiteUrl, selectFormSecurityToken } from 'core/selectors/app';
import {
  selectEmailOptInSubscribeModalConfig, selectEmailOptInSubscribeModalUserChoiceSubmitted,
} from 'core/modules/Modals/EmailOptInSubscribeModal/selectors';
import {
  EMAIL_OPT_IN_MODAL_USER_CHOICE_UNDECIDED, EMAIL_OPT_IN_MODAL_USER_CHOICE_YES,
} from 'core/modules/Modals/EmailOptInSubscribeModal/constants';
import orgConfig from 'org/configs/org.config';
import config from './configs';
import { triggerOnboardingEmailOptInClicked } from '../../actions';
import { EMAIL_MESSAGE } from '../SlideMessage/utils/constants';

function Email({
  updateEmailPopUpCookie, sequenceValue, goToNextStepOrFinish, stepsData,
}) {
  const dispatch = useDispatch();

  const {
    shouldOptInBeCheckedByDefault, optInHeadingText, getOptInText, labelText, getEmailDisclaimerText,
  } = config;

  const [optInChecked, setOptInChecked] = useState(shouldOptInBeCheckedByDefault);
  const [emailOptedIn, setEmailOptedIn] = useState(false);
  const [disableEmailOptinNextButton, setDisableEmailOptinNextButton] = useState(false);

  const siteUrl = useSelector(selectSiteUrl);
  const emailConfig = useSelector(selectEmailOptInSubscribeModalConfig);
  const securityToken = useSelector(selectFormSecurityToken);
  const emailOptInSubmitted = useSelector(selectEmailOptInSubscribeModalUserChoiceSubmitted);

  useEffect(() => {
    emailOptInSubmitted && goToNextStepOrFinish();
  },
  [emailOptInSubmitted]);

  const { earnType, shortProgramName } = orgConfig;
  const optInText = getOptInText(earnType);
  const emailDisclaimerText = getEmailDisclaimerText(shortProgramName);

  const handleOptInCheck = () => setOptInChecked(!optInChecked);

  const handleEmailOptinClickWithOptinSubmit = () => {
    setDisableEmailOptinNextButton(true);
    updateEmailPopUpCookie(optInChecked);
    dispatch(triggerOnboardingEmailOptInClicked(sequenceValue, optInChecked)); // triggers GA event

    if (optInChecked) {
      // submits form to actually opt in user - only need to fire if user is opting in
      setEmailOptedIn(true);
    } else {
      dispatch(postEmailOptInUserChoice(EMAIL_OPT_IN_MODAL_USER_CHOICE_UNDECIDED)); // updates metadata
    }
  };

  const handleEmailOptinSubmitFinished = () => {
    dispatch(postEmailOptInUserChoice(EMAIL_OPT_IN_MODAL_USER_CHOICE_YES));
  };

  return (
    <div className="mn_slide mn_slideEmail">
      <SlideMessage step={EMAIL_MESSAGE} />
      <div className="mn_content">
        <SlideCounter stepsData={stepsData} />
        <div className="mn_gap" />
        { emailOptedIn &&
          <EmailOptInSubscribeForm
            useAjax
            siteUrl={siteUrl}
            securityToken={securityToken}
            {...emailConfig}
            callback={handleEmailOptinSubmitFinished}
          />
        }
        <div className="mn_optInImage" />
        <h2>{optInHeadingText}<span className="mn_dot">.</span></h2>
        <p>{optInText}</p>
        <div className="mn_checkbox">
          <input
            id="mn_optInToEmails"
            type="checkbox"
            onChange={handleOptInCheck}
            checked={optInChecked}
          />
          <label htmlFor="mn_optInToEmails">{labelText}</label>
        </div>
        {emailDisclaimerText && <div className="mn_emailDisclaimer">{emailDisclaimerText}</div>}
        <div className="mn_bottomContent">
          <button
            className="mn_button mn_stepButton mn_stepOptinDone"
            disabled={disableEmailOptinNextButton}
            onClick={handleEmailOptinClickWithOptinSubmit}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default Email;
